module.exports = __webpack_public_path__ + "static/13-thumb-231de9575b2676d803e250135751a4bc.jpg";